export class EventTagDTO {
	label: string;
	color: string;

	constructor(tag: any) {
		this.label = tag.label;
		this.color = tag.color;
	}
}
